import React,{useState, useEffect} from 'react'
import $ from 'jquery';
import {environment} from './../environment/production'
import axios from 'axios';
import { useNavigate } from "react-router-dom";

function FinalSubmit(props) {
  const [minFromDate,setMinFromDate]=useState(new Date())
  const [maxFromDate,setMaxFromDate]=useState(new Date())
  const [minToDate,setMinToDate]=useState(new Date())
  const [maxToDate,setMaxToDate]=useState(new Date())
  const navigate = useNavigate();
  const [apiCall,setApiCall]=useState(0)
  const [formdata, setFormData] = useState({
    user_id:parseInt(sessionStorage.getItem("user_id")),
    final_submit_date:'',//formatDate(new Date())
    // declaration:'',
  });
  const options={
    data:{
      formdata
    },
    headers:{
        'Authorization':sessionStorage.getItem("access_token")
    }
  }
  const [isChecked, setIsChecked] = useState(true);
  function fromDateChange() {
 
    setMinFromDate(formatDate(new Date()))
  }
  function handleFormData(event){
    event.preventDefault()
    
    if(event.target.declaration.value=='on' && event.target.date_of_form_filled.value!==""){
      formdata.final_submit_date=event.target.date_of_form_filled.value;
      setFormData(...[formdata])
      axios.post(environment.apiUrl+"/FinalSubmit/save_data",JSON.stringify(options.data.formdata),{headers:(options.headers)})
      .then((response)=>{
       
        if(response.data.status==1){
          props.data(isChecked)
          
          alert("Your Data Updated Successfully")
        }else{
          alert(response['data']['msg'])
        }
      })
    }else{
      props.data(isChecked)
    }
  };
  function getFinalSubmit(){
    axios.post(environment.apiUrl+"/FinalSubmit/getFinalSubmit",JSON.stringify({user_id:sessionStorage.getItem("user_id")}),{headers:(options.headers)})
    .then((resp)=>{
      if(resp['data']['status']==1){
        props.data(resp['data']['status'])
        //console.log(resp.data.data[0]['final_submit_date'])
        setFormData({...formdata,final_submit_date:resp.data.data[0]['final_submit_date']})
      }else{
        props.data(resp['data']['status'])
      }
    })
  }
  useEffect(()=>{
    if(apiCall==0){
      getFinalSubmit()
      fromDateChange()
    }
    setApiCall(1)
   },[apiCall])

  function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

  return (
    <>
    <div className="container-fluid page-body-wrapper">
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="card-title">Final Submit</h4>
                        <p className="card-description"> Kindly check declaration </p>
                        <form className="forms-sample" onSubmit={(event)=>handleFormData(event)}>
                            <div className="row">
                                <div className="col-3">
                                    <label>Date <span className="text-danger">*</span></label>
                                    <input className="form-control" min={minFromDate} max={minToDate} defaultValue={formdata.final_submit_date} type="date" id="date_of_form_filled" name="date_of_form_filled" />
                                </div>
                            </div><br/><br/>
      
                            <div className="row">
                              <div className="col-1">
                                   
                              <input
                                type="checkbox"
                                defaultChecked={isChecked}
                                name="declaration"
                                id="declaration"
                               onChange={(e)=>setIsChecked(e.target.value)}
                              />
                            </div>
                            
                                <div className="col-10" style={{textAlign:'left'}}>
                                {/* style={{marginLeft: '-5%'}} */}
                                    <h6>I do hereby declare that the information/ details provided by me are correct and true to the best of my knowledge and no material fact having a bearing on my selection has been suppressed/ withheld. <span className="text-danger">*</span></h6>
                                </div>
                               
                            </div>
                              
                            <br/><br/>
                         
                            <button type="submit" className="btn btn-primary me-2">Save</button>
                          
                         
                        </form>
                       <br/><br/> <button type="submit" className="btn btn-danger" onClick={()=>{navigate("/preview-before-sumbit")}} style={{textAlign: 'center'}}>Preview</button>
                      </div>
                    </div>
                  </div>
                </div>
    </>
  )
}

export default FinalSubmit